import React, { useState } from "react";
import ReactFlow, {
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from "react-flow-renderer";

// Entscheidungsbaum-Daten

const treeCollection = {
  ransomwareScenario: {
    start: {
      question:
        "Du entdeckst verdächtige Aktivitäten auf deinem Netzwerk. Was tust du?",
      options: [
        {
          text: "IT-Sicherheitsteam benachrichtigen",
          next: "notifyTeam",
          result: "Gute Entscheidung! Das Team beginnt mit der Analyse.",
        },
        {
          text: "Abwarten, ob es ernst ist",
          next: "waitAndSee",
          result: "Das Risiko steigt erheblich!",
        },
      ],
    },
    waitAndSee: {
      question:
        "Die verdächtigen Aktivitäten eskalieren zu einem Angriff. Was tust du jetzt?",
      options: [
        {
          text: "Notfallprotokoll aktivieren",
          next: "notifyTeam",
          result: "Du reagierst spät, aber es ist noch nicht zu spät!",
        },
        {
          text: "Versuchen, das Problem selbst zu lösen",
          next: "selfSolve",
          result: "Du verlierst wertvolle Zeit und verschärfst das Problem!",
        },
      ],
    },
    selfSolve: {
      question:
        "Du versuchst, das Problem selbst zu lösen. Die Angreifer breiten sich jedoch weiter aus. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Notfallprotokoll aktivieren",
          next: "notifyTeam",
          result:
            "Das Protokoll wird gestartet, aber wertvolle Zeit wurde verschwendet.",
        },
        {
          text: "Externe Experten hinzuziehen",
          next: "externalHelp",
          result:
            "Die Experten helfen, die Situation unter Kontrolle zu bringen.",
        },
      ],
    },

    notifyTeam: {
      question:
        "Das IT-Sicherheitsteam bestätigt einen Ransomware-Angriff. Was ist der nächste Schritt?",
      options: [
        {
          text: "Systeme isolieren",
          next: "isolateSystems",
          result: "Richtige Entscheidung! Der Schaden wird begrenzt.",
        },
        {
          text: "Keine Maßnahmen ergreifen und Lösegeldforderung prüfen",
          next: "checkRansom",
          result: "Das Risiko steigt, da der Angriff sich ausbreitet.",
        },
      ],
    },
    isolateSystems: {
      question: "Die Systeme sind isoliert. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Backup überprüfen und Wiederherstellung starten",
          next: "checkBackup",
          result: "Gute Wahl! Du kannst Daten retten.",
        },
        {
          text: "Lösegeldforderung verhandeln",
          next: "negotiateRansom",
          result: "Du begibst dich in eine schwierige Situation.",
        },
      ],
    },
    checkBackup: {
      question: "Deine Backups sind beschädigt. Was tust du?",
      options: [
        {
          text: "Externe Experten hinzuziehen",
          next: "externalHelp",
          result: "Experten helfen, die Situation zu bewältigen.",
        },
        {
          text: "Alle Systeme herunterfahren",
          next: "shutdown",
          result: "Das Unternehmen steht still, aber der Schaden ist begrenzt.",
        },
      ],
    },

    checkRansom: {
      question:
        "Die Angreifer fordern ein Lösegeld von 1 Million Euro. Wie gehst du vor?",
      options: [
        {
          text: "Lösegeld zahlen",
          next: "payRansom",
          result: "Du riskierst, dass die Angreifer erneut zuschlagen!",
        },
        {
          text: "Nicht zahlen und Polizei informieren",
          next: "policeReport",
          result: "Richtige Entscheidung! Die Behörden unterstützen dich.",
        },
      ],
    },
    payRansom: {
      question:
        "Das Lösegeld wurde bezahlt, aber die Angreifer geben keine Garantie für die Freigabe der Systeme. Was tust du?",
      options: [
        {
          text: "Angreifer weiter beobachten",
          next: "monitorAttack",
          result:
            "Du erhältst wertvolle Erkenntnisse, aber das Risiko bleibt bestehen.",
        },
        {
          text: "Systeme neu aufsetzen und Schwachstellen schließen",
          next: "patchAndRecover",
          result: "Das Risiko wurde minimiert, und die Systeme sind sicherer.",
        },
      ],
    },

    negotiateRansom: {
      question:
        "Die Angreifer fordern 1 Million Euro. Was ist deine Entscheidung?",
      options: [
        {
          text: "Lösegeld zahlen",
          next: "payRansom",
          result: "Du riskierst, dass die Angreifer erneut zuschlagen!",
        },
        {
          text: "Nicht zahlen und die Polizei informieren",
          next: "policeReport",
          result: "Richtige Entscheidung! Die Behörden unterstützen dich.",
        },
      ],
    },
    externalHelp: {
      question:
        "Die Experten identifizieren die Schwachstelle. Was machst du als Nächstes?",
      options: [
        {
          text: "Schwachstelle patchen und Systeme neu aufsetzen",
          next: "patchAndRecover",
          result: "Gute Entscheidung! Du stärkst die Sicherheitslage.",
        },
        {
          text: "Angreifer weiter beobachten",
          next: "monitorAttack",
          result: "Das Risiko bleibt bestehen.",
        },
      ],
    },
    incompleteReport: {
      question:
        "Die Behörden erhalten nur grundlegende Informationen. Dadurch wird die Untersuchung erschwert. Wie gehst du weiter vor?",
      options: [
        {
          text: "Detaillierte Berichte nachreichen",
          next: "completeReport",
          result:
            "Du hast die Ermittlungen unterstützt und die Schwachstellenanalyse verbessert.",
        },
        {
          text: "Keine weiteren Informationen bereitstellen",
          next: "end",
          result:
            "Die Untersuchung bleibt unvollständig, und potenzielle Risiken werden nicht beseitigt.",
        },
      ],
    },

    completeReport: {
      question:
        "Du hast alle Vorfälle dokumentiert und den Behörden bereitgestellt. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Mit den Behörden zusammenarbeiten, um Schwachstellen zu identifizieren",
          next: "patchAndRecover",
          result:
            "Die Zusammenarbeit verbessert deine Sicherheitslage erheblich.",
        },
        {
          text: "Den Betrieb normal fortsetzen",
          next: "end",
          result:
            "Das Szenario ist abgeschlossen, aber weitere Maßnahmen könnten erforderlich sein.",
        },
      ],
    },
    policeReport: {
      question: "Die Polizei fordert detaillierte Berichte. Wie gehst du vor?",
      options: [
        {
          text: "Alle Vorfälle dokumentieren und bereitstellen",
          next: "completeReport",
          result: "Richtige Entscheidung! Die Ermittlungen laufen an.",
        },
        {
          text: "Nur grundlegende Informationen bereitstellen",
          next: "incompleteReport",
          result: "Die Ermittlungen werden erschwert.",
        },
      ],
    },
    monitorAttack: {
      question:
        "Du beobachtest weiterhin die Aktivitäten der Angreifer. Sie bleiben aktiv und versuchen, sich erneut Zugriff zu verschaffen. Was tust du?",
      options: [
        {
          text: "Systeme sofort herunterfahren",
          next: "shutdown",
          result: "Der Angriff wird gestoppt, aber der Betrieb steht still.",
        },
        {
          text: "Schwachstelle identifizieren und patchen",
          next: "patchAndRecover",
          result:
            "Du schließt die Sicherheitslücke und minimierst zukünftige Risiken.",
        },
      ],
    },
    shutdown: {
      question:
        "Du hast die Systeme vollständig heruntergefahren, und der Angriff wurde gestoppt. Wie gehst du jetzt vor?",
      options: [
        {
          text: "Systeme sicher wieder hochfahren und Schwachstellen analysieren",
          next: "patchAndRecover",
          result:
            "Die Systeme werden sicher wiederhergestellt, und Schwachstellen werden behoben.",
        },
        {
          text: "Externe Experten für forensische Analysen hinzuziehen",
          next: "externalHelp",
          result:
            "Die Experten identifizieren Schwachstellen und bieten Lösungen an.",
        },
      ],
    },

    patchAndRecover: {
      question:
        "Die Systeme sind wiederhergestellt. Was ist dein langfristiger Plan?",
      options: [
        {
          text: "Mitarbeiter schulen und Sicherheitsrichtlinien verschärfen",
          next: "trainStaff",
          result: "Dein Unternehmen wird widerstandsfähiger.",
        },
        {
          text: "Keine weiteren Maßnahmen",
          next: "end",
          result: "Das Risiko für zukünftige Angriffe bleibt hoch.",
        },
      ],
    },
    trainStaff: {
      question:
        "Das Training ist abgeschlossen. Wie schätzt du den Sicherheitsstatus ein?",
      options: [
        {
          text: "Fortschritt bewerten und Szenario abschließen",
          next: "end",
          result:
            "Das Training war erfolgreich und hat die Widerstandsfähigkeit gesteigert.",
        },
      ],
    },
    end: {
      question: "Das Szenario ist beendet.",
      options: [],
      result:
        "Überlege, wie du in Zukunft besser handeln kannst. Gutes Cybersecurity-Management erfordert ständige Wachsamkeit und Verbesserung.",
    },
  },

  cyberAttack: {
    start: {
      question:
        "Dein Unternehmen wird Ziel eines Cyberangriffs. Ein Mitarbeiter meldet einen verdächtigen Link in einer E-Mail. Was tust du?",
      options: [
        {
          text: "Link ignorieren und weitermachen",
          next: "ignoreLink",
          result: "Der Angriff bleibt unbemerkt und breitet sich aus.",
        },
        {
          text: "IT-Sicherheitsteam informieren",
          next: "notifyIT",
          result: "Gute Entscheidung! Das Team beginnt mit der Analyse.",
        },
      ],
    },
    ignoreLink: {
      question:
        "Später berichten mehrere Mitarbeiter über ungewöhnliches Verhalten ihrer Systeme. Wie reagierst du?",
      options: [
        {
          text: "Sicherheitsprotokoll aktivieren",
          next: "activateProtocol",
          result: "Du reagierst spät, aber es könnte Schlimmeres verhindern.",
        },
        {
          text: "Weiter abwarten",
          next: "escalate",
          result: "Die Bedrohung eskaliert schnell.",
        },
      ],
    },
    notifyIT: {
      question:
        "Das IT-Sicherheitsteam entdeckt, dass es sich um einen Phishing-Angriff handelt. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Betroffene Systeme isolieren",
          next: "isolateSystems",
          result: "Der Schaden wird begrenzt.",
        },
        {
          text: "Warnung an alle Mitarbeiter senden",
          next: "warnEmployees",
          result: "Mitarbeiter werden über den Angriff informiert.",
        },
      ],
    },
    internalFix: {
      question:
        "Das IT-Team arbeitet daran, den Angriff zu neutralisieren. Der Fortschritt ist langsam. Was tust du?",
      options: [
        {
          text: "Externe Experten hinzuziehen",
          next: "externalHelp",
          result: "Die Experten helfen, den Angriff schneller zu bewältigen.",
        },
        {
          text: "Weitere interne Ressourcen zuweisen",
          next: "internalResources",
          result:
            "Die Lösung wird beschleunigt, aber die Kapazitäten sind ausgelastet.",
        },
      ],
    },

    internalResources: {
      question:
        "Die internen Ressourcen reichen nicht aus, und der Angriff eskaliert. Was machst du?",
      options: [
        {
          text: "Systeme herunterfahren",
          next: "shutdown",
          result: "Der Angriff wird gestoppt, aber der Betrieb steht still.",
        },
        {
          text: "Behörden einschalten",
          next: "contactAuthorities",
          result: "Die Behörden unterstützen bei der Schadensbewältigung.",
        },
      ],
    },
    isolateMore: {
      question:
        "Die Systeme wurden stärker isoliert, aber der Angriff dauert an. Was machst du als Nächstes?",
      options: [
        {
          text: "Externe Experten hinzuziehen",
          next: "externalHelp",
          result: "Die Experten helfen, die Bedrohung einzudämmen.",
        },
        {
          text: "Angreifer beobachten und analysieren",
          next: "monitorAttack",
          result: "Du gewinnst Erkenntnisse, aber der Angriff bleibt aktiv.",
        },
      ],
    },
    monitorAttack: {
      question:
        "Du analysierst den Angriff und gewinnst wertvolle Erkenntnisse. Was machst du als Nächstes?",
      options: [
        {
          text: "Angriff stoppen und Schwachstelle patchen",
          next: "patchAndRecover",
          result:
            "Der Angriff wird erfolgreich beendet, und die Systeme sind sicherer.",
        },
        {
          text: "Weiter beobachten",
          next: "end",
          result: "Das Risiko bleibt bestehen, und der Angriff dauert an.",
        },
      ],
    },
    shutdown: {
      question:
        "Die Systeme wurden vollständig heruntergefahren, und der Angriff wurde gestoppt. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Systeme sicher wieder hochfahren und Schwachstellen analysieren",
          next: "patchAndRecover",
          result:
            "Die Systeme werden sicher wiederhergestellt, und Schwachstellen werden behoben.",
        },
        {
          text: "Externe Experten für forensische Analysen hinzuziehen",
          next: "externalHelp",
          result:
            "Die Experten analysieren die Ursachen und geben Empfehlungen für zukünftige Schutzmaßnahmen.",
        },
      ],
    },
    isolateSystems: {
      question: "Die Systeme sind isoliert. Was tust du als Nächstes?",
      options: [
        {
          text: "Externe Experten hinzuziehen",
          next: "externalHelp",
          result: "Experten helfen bei der Analyse.",
        },
        {
          text: "Versuchen, den Angriff intern zu lösen",
          next: "internalFix",
          result: "Das Team arbeitet daran, den Angriff zu neutralisieren.",
        },
      ],
    },
    warnEmployees: {
      question:
        "Ein Mitarbeiter meldet, dass er den Link bereits geöffnet hat. Wie gehst du vor?",
      options: [
        {
          text: "System sofort isolieren",
          next: "isolateSystems",
          result: "Der Schaden wird begrenzt.",
        },
        {
          text: "Weiterhin alle Mitarbeiter warnen",
          next: "warnMore",
          result: "Einige Mitarbeiter reagieren, aber die Bedrohung bleibt.",
        },
      ],
    },
    warnMore: {
      question:
        "Die Angreifer starten eine DDoS-Attacke, die die Systeme überlastet. Was tust du?",
      options: [
        {
          text: "Firewall-Regeln anpassen",
          next: "adjustFirewall",
          result: "Der Datenverkehr wird kontrolliert.",
        },
        {
          text: "Abwarten, bis die Attacke endet",
          next: "waitDdos",
          result: "Der Angriff verursacht erhebliche Schäden.",
        },
      ],
    },
    externalHelp: {
      question:
        "Die Experten empfehlen, die Systeme herunterzufahren. Was machst du?",
      options: [
        {
          text: "Systeme herunterfahren",
          next: "shutdown",
          result: "Der Angriff wird gestoppt, aber der Betrieb steht still.",
        },
        {
          text: "Weiterhin Systeme isolieren",
          next: "isolateMore",
          result: "Der Schaden wird begrenzt, aber der Angriff dauert an.",
        },
      ],
    },
    escalate: {
      question:
        "Die Angreifer haben Zugriff auf sensible Daten erhalten. Wie reagierst du?",
      options: [
        {
          text: "Behörden einschalten",
          next: "contactAuthorities",
          result: "Die Behörden beginnen mit der Untersuchung.",
        },
        {
          text: "Angreifer beobachten",
          next: "monitorAttack",
          result: "Die Bedrohung bleibt bestehen.",
        },
      ],
    },
    adjustFirewall: {
      question: "Der DDoS-Angriff wurde abgewehrt. Was tust du als Nächstes?",
      options: [
        {
          text: "Systeme auf Schwachstellen überprüfen",
          next: "vulnerabilityCheck",
          result: "Schwachstellen werden identifiziert und behoben.",
        },
        {
          text: "Keine weiteren Maßnahmen ergreifen",
          next: "end",
          result: "Das Risiko für zukünftige Angriffe bleibt hoch.",
        },
      ],
    },
    contactAuthorities: {
      question: "Die Behörden verlangen detaillierte Berichte. Was machst du?",
      options: [
        {
          text: "Alle Vorfälle dokumentieren und weitergeben",
          next: "completeReport",
          result: "Die Ermittlungen laufen effektiv an.",
        },
        {
          text: "Nur grundlegende Informationen bereitstellen",
          next: "incompleteReport",
          result: "Die Ermittlungen werden erschwert.",
        },
      ],
    },
    vulnerabilityCheck: {
      question:
        "Die Schwachstellen sind behoben. Was ist dein langfristiger Plan?",
      options: [
        {
          text: "Mitarbeiterschulungen und Sicherheitsrichtlinien aktualisieren",
          next: "trainStaff",
          result: "Dein Unternehmen wird widerstandsfähiger.",
        },
        {
          text: "Keine weiteren Maßnahmen",
          next: "end",
          result: "Das Risiko für zukünftige Angriffe bleibt bestehen.",
        },
      ],
    },
    patchAndRecover: {
      question:
        "Die Schwachstellen wurden identifiziert und behoben. Was ist dein nächster Schritt, um die Sicherheit langfristig zu gewährleisten?",
      options: [
        {
          text: "Mitarbeiter schulen und Sicherheitsrichtlinien aktualisieren",
          next: "trainStaff",
          result:
            "Dein Unternehmen wird widerstandsfähiger gegen zukünftige Angriffe.",
        },
        {
          text: "Keine weiteren Maßnahmen ergreifen",
          next: "end",
          result: "Das Risiko für zukünftige Angriffe bleibt bestehen.",
        },
      ],
    },

    trainStaff: {
      question:
        "Das Training ist abgeschlossen. Wie bewertest du den Sicherheitsstatus?",
      options: [],
      result:
        "Du hast die Widerstandsfähigkeit deines Unternehmens deutlich verbessert. Gute Arbeit!",
    },
    end: {
      question: "Das Szenario ist beendet.",
      options: [],
      result: "Überlege, wie du in Zukunft besser handeln kannst.",
    },
  },
  doraImplementation: {
    start: {
      question:
        "Dein Unternehmen plant die Umsetzung der DORA-Verordnung. Was ist dein erster Schritt?",
      options: [
        {
          text: "Risikoanalyse durchführen",
          next: "conductRiskAnalysis",
          result:
            "Guter Start! Du gewinnst einen Überblick über potenzielle Schwachstellen.",
        },
        {
          text: "Drittanbieter überprüfen",
          next: "reviewThirdParties",
          result:
            "Wichtiger Schritt, aber eine Risikoanalyse sollte vorab erfolgen.",
        },
      ],
    },
    conductRiskAnalysis: {
      question:
        "Die Risikoanalyse zeigt Schwachstellen in deiner IT-Infrastruktur. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Schwachstellen priorisieren und beheben",
          next: "fixVulnerabilities",
          result:
            "Du minimierst kritische Risiken und verbesserst deine IT-Sicherheit.",
        },
        {
          text: "Ergebnisse dokumentieren und Bericht erstellen",
          next: "documentAnalysis",
          result:
            "Guter Schritt! Dokumentation ist ein zentraler Bestandteil von DORA.",
        },
      ],
    },
    fixVulnerabilities: {
      question:
        "Die Schwachstellen wurden behoben. Was ist der nächste Schritt?",
      options: [
        {
          text: "Bericht an die Geschäftsleitung und Behörden übermitteln",
          next: "submitReport",
          result:
            "Die Behörden erhalten die erforderlichen Informationen zur Compliance.",
        },
        {
          text: "Drittanbieter auf Sicherheitsstandards überprüfen",
          next: "reviewThirdParties",
          result: "Eine sinnvolle Maßnahme, um die Lieferkette zu sichern.",
        },
      ],
    },
    documentAnalysis: {
      question: "Die Dokumentation ist abgeschlossen. Wie gehst du weiter?",
      options: [
        {
          text: "Mitarbeiter über die Ergebnisse informieren",
          next: "trainStaff",
          result:
            "Gute Entscheidung! Informierte Mitarbeiter stärken die Resilienz.",
        },
        {
          text: "Drittanbieter überprüfen",
          next: "reviewThirdParties",
          result: "Ein wichtiger Schritt, um die Lieferkette abzusichern.",
        },
      ],
    },
    reviewThirdParties: {
      question:
        "Ein Drittanbieter entspricht nicht den Sicherheitsstandards. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Drittanbieter wechseln",
          next: "changeThirdParty",
          result:
            "Eine drastische, aber notwendige Maßnahme zur Risikominderung.",
        },
        {
          text: "Sicherheitsanforderungen mit dem Anbieter vereinbaren",
          next: "negotiateStandards",
          result:
            "Ein sinnvoller Schritt, um die Zusammenarbeit zu verbessern.",
        },
      ],
    },
    changeThirdParty: {
      question:
        "Du hast den Drittanbieter gewechselt. Was ist der nächste Schritt?",
      options: [
        {
          text: "Sicherheitsprüfungen für alle Drittanbieter durchführen",
          next: "auditThirdParties",
          result:
            "Du stellst sicher, dass alle Anbieter den Standards entsprechen.",
        },
        {
          text: "Systeme auf neue Anbieter abstimmen",
          next: "adjustSystems",
          result:
            "Gute Entscheidung! Eine reibungslose Integration ist wichtig.",
        },
      ],
    },
    negotiateStandards: {
      question:
        "Der Anbieter akzeptiert die neuen Sicherheitsanforderungen. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Regelmäßige Sicherheitsaudits vereinbaren",
          next: "auditThirdParties",
          result: "Du stellst sicher, dass die Standards eingehalten werden.",
        },
        {
          text: "Überwachungssysteme implementieren",
          next: "implementMonitoring",
          result:
            "Eine wichtige Maßnahme, um Bedrohungen frühzeitig zu erkennen.",
        },
      ],
    },
    auditThirdParties: {
      question:
        "Die Audits zeigen keine weiteren Schwachstellen. Was ist dein nächster Schritt?",
      options: [
        {
          text: "Mitarbeiter für die neuen Anforderungen schulen",
          next: "trainStaff",
          result:
            "Eine geschulte Belegschaft ist entscheidend für die Resilienz.",
        },
        {
          text: "Notfallpläne aktualisieren",
          next: "updatePlans",
          result: "Wichtig, um auf zukünftige Vorfälle vorbereitet zu sein.",
        },
      ],
    },
    implementMonitoring: {
      question:
        "Die Überwachungssysteme sind in Betrieb. Was möchtest du als nächstes tun?",
      options: [
        {
          text: "Regelmäßige Tests der Systeme durchführen",
          next: "testSystems",
          result: "Gute Entscheidung! Tests verbessern die Sicherheit.",
        },
        {
          text: "Mitarbeiter für Vorfallsreaktionen schulen",
          next: "trainStaff",
          result:
            "Eine geschulte Belegschaft reagiert effektiver auf Vorfälle.",
        },
      ],
    },
    trainStaff: {
      question:
        "Das Training ist abgeschlossen. Wie bewertest du die Fortschritte?",
      options: [],
      result:
        "Du hast die Widerstandsfähigkeit deines Unternehmens erheblich verbessert. Gute Arbeit!",
    },
    updatePlans: {
      question:
        "Die Notfallpläne wurden aktualisiert. Was ist dein nächster Schritt?",
      options: [],
      result:
        "Dein Unternehmen ist nun besser auf zukünftige Herausforderungen vorbereitet.",
    },
    testSystems: {
      question:
        "Die Tests zeigen, dass die Systeme sicher sind. Was ist dein nächster Schritt?",
      options: [],
      result:
        "Dein Unternehmen erfüllt die DORA-Anforderungen und stärkt seine Resilienz.",
    },
    submitReport: {
      question: "Der Bericht wurde übermittelt. Wie gehst du weiter?",
      options: [],
      result:
        "Du hast die Compliance sichergestellt und die behördlichen Anforderungen erfüllt.",
    },
    adjustSystems: {
      question:
        "Die Systeme wurden an die neuen Anbieter angepasst. Wie gehst du weiter?",
      options: [],
      result:
        "Die Integration ist abgeschlossen, und dein Unternehmen ist sicherer.",
    },
  },
};

const generateFeedback = (history) => {
  let positives = 0;
  let negatives = 0;

  // Entscheidungen durchgehen und bewerten
  history.forEach((entry) => {
    if (
      entry.result.includes("Gute Entscheidung") ||
      entry.result.includes("Gute Wahl")
    ) {
      positives++;
    } else {
      negatives++;
    }
  });

  // Feedback basierend auf den Entscheidungen
  const feedback =
    positives > negatives
      ? "Du hast in den meisten Fällen richtig reagiert und die Sicherheitslage erheblich verbessert. Hervorragend!"
      : "Es gibt noch Verbesserungspotenzial in deinem Vorgehen. Einige Entscheidungen könnten die Sicherheitslage verschlechtern.";

  // Empfehlungen
  let recommendations =
    negatives > 0
      ? "Um dich besser auf zukünftige Angriffe vorzubereiten, solltest du deine Schwachstellen analysieren und das IT-Sicherheitsteam besser schulen."
      : "Weiter so! Eine kontinuierliche Verbesserung und regelmäßige Sicherheitsprüfungen sind der Schlüssel zu nachhaltiger Cybersecurity.";

  // Zusätzliche spezifische Empfehlungen
  if (!history.some((entry) => entry.answer.includes("Backup überprüfen"))) {
    recommendations +=
      " Stelle sicher, dass du regelmäßig Backups überprüfst, um Datenverluste zu vermeiden.";
  }
  if (history.some((entry) => entry.answer.includes("Lösegeld zahlen"))) {
    recommendations +=
      " Lösegeldzahlungen sind riskant. Überlege in Zukunft, alternative Maßnahmen zu ergreifen.";
  }

  return { feedback, recommendations };
};

const DecisionTreeGraph = () => {
  const [selectedScenario, setSelectedScenario] = useState(null);
  const [currentNode, setCurrentNode] = useState("start");
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [history, setHistory] = useState([]);

  const handleScenarioSelection = (scenario) => {
    setSelectedScenario(scenario);
    setCurrentNode("start");
    setNodes([]);
    setEdges([]);
    setHistory([]);

    // Initialer Knoten
    setNodes([
      {
        id: "start",
        data: { label: treeCollection[scenario]?.start.question || "Start" },
        position: { x: 250, y: 0 },
        draggable: true,
      },
    ]);
  };

  const handleOptionClick = (option) => {
    const nextNode = treeCollection[selectedScenario]?.[option.next];
    if (!nextNode) {
      alert(
        `Ein Fehler ist aufgetreten: Der nächste Knoten "${option.next}" wurde nicht gefunden.`
      );
      return;
    }

    // Überprüfen, ob der Knoten bereits existiert
    const nodeExists = nodes.find((node) => node.id === option.next);
    if (!nodeExists) {
      setNodes((prevNodes) => [
        ...prevNodes,
        {
          id: option.next,
          data: { label: nextNode.question || "Ende" },
          position: { x: Math.random() * 400, y: Math.random() * 400 },
          draggable: true,
        },
      ]);
    }

    setEdges((prevEdges) =>
      addEdge(
        {
          id: `${currentNode}-${option.next}`,
          source: currentNode,
          target: option.next,
          label: option.text,
        },
        prevEdges
      )
    );

    setHistory((prevHistory) => [
      ...prevHistory,
      {
        question: treeCollection[selectedScenario][currentNode].question,
        answer: option.text,
        result: option.result,
      },
    ]);

    setCurrentNode(option.next);
  };

  const node =
    selectedScenario && treeCollection[selectedScenario]?.[currentNode];

  // Dynamisches Feedback generieren
  const feedback = currentNode === "end" ? generateFeedback(history) : null;

  return (
    <div className="p-5">
      {!selectedScenario && (
        <div>
          <h5>
            Wähle ein Szenario aus:
            <br />
            <br />
          </h5>
          <div class="container text-center">
            <div class="row align-items-start">
              <div class="col">
                <button
                  className="btn btn-primary mb-3"
                  onClick={() => handleScenarioSelection("cyberAttack")}
                >
                  Cyberangriff
                </button>
              </div>
              <div class="col">
                <button
                  className="btn btn-primary mb-3"
                  onClick={() => handleScenarioSelection("ransomwareScenario")}
                >
                  Ransomware-Angriff
                </button>
              </div>
              <div class="col">
                {" "}
                <button
                  className="btn btn-primary mb-3"
                  onClick={() => handleScenarioSelection("doraImplementation")}
                >
                  DORA-Implementation
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedScenario && node && (
        <div>
          <h5>{node.question}</h5>
          <ul className="list-unstyled">
            {node.options.map((option, index) => (
              <li key={index} className="mb-3">
                <button
                  className="btn btn-secondary"
                  onClick={() => handleOptionClick(option)}
                >
                  {option.text}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div
        style={{ height: "500px", border: "1px solid #ddd", marginTop: "20px" }}
      >
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          fitView
        >
          <Controls />
          <Background />
        </ReactFlow>
      </div>

      <h6 className="mt-4">Dein Entscheidungsverlauf:</h6>
      <ul>
        {history.map((entry, index) => (
          <li key={index}>
            <strong>Frage:</strong> {entry.question} <br />
            <strong>Deine Antwort:</strong> {entry.answer} <br />
            <strong>Ergebnis:</strong> {entry.result}
          </li>
        ))}
      </ul>

      {currentNode === "end" && feedback && (
        <div className="mt-4">
          <h5>Ergebnisbewertung</h5>
          <p>{feedback.feedback}</p>
          <h6>Empfehlungen</h6>
          <p>{feedback.recommendations}</p>
        </div>
      )}

      <div className="mt-3">
        <button
          className="btn btn-secondary"
          onClick={() => setSelectedScenario(null)}
        >
          Szenario wechseln
        </button>
      </div>
    </div>
  );
};

export default DecisionTreeGraph;
